import styled, { css } from 'styled-components'
import { Link as BaseLink } from 'react-router-dom'

export const Link = styled(BaseLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;

  ${props =>
    props.size === 'sm'
      ? css`
          font-size: 0.75rem;
        `
      : props.size === 'lg'
        ? css`
          font-size: 0.875rem;
        `
        : css`
          font-size: 0.875rem;
        `}

  ${props =>
    props.color === 'default'
      ? css`
          color: ${props.theme.button.default.in};
          ${!props.disabled &&
        css`
              &:hover {
                color: ${props.theme.button.default.out};
              }
            `}
          &:disabled {
            cursor: not-allowed;
          }
        `
      : props.color === 'primary'
        ? css`
          color: ${props.theme.button.primary.out};
          ${!props.disabled &&
          css`
              &:hover {
                color: ${props.theme.button.primary.in};
              }
            `}
        `
        : props.color === 'font'
          ? css`
          color: ${props.theme.fontColor};
          opacity: 1;
          ${!props.disabled &&
            css`
              &:hover {
                color: ${props.theme.fontColor};
                opacity: 0.8;
              }
            `}
        `
          : ``}

${props =>
    props.disabled &&
    css`
    cursor: not-allowed;
  `}



svg {
  /* margin-right: 5px; */
  margin-left: 5px;
  stroke-width: 1px;
  font-size: 24px;
}
`
